/// <summary>
/// Lists all currently-known feature flags, in alphabetical order.
///
/// Keep in sync with Features.cs in Omnius.Custom.Common
/// </summary>
enum Features {
    ACCURACY_ENABLE_LOCATION_CERTIFIED_SKILLED_MEDICAL_INTERPRETER = "AccuracyEnableLocationCertifiedSkilledMedicalInterpreter",
    ACCURACY_ENABLE_LOCATION_GENDER_AFFIRMING_CARE = "AccuracyEnableLocationGenderAffirmingCare",
    ACCURACY_ENABLE_PRAC_AT_LOC_CONFIDENCE = "AccuracyEnablePracAtLocConfidence",
    ACCURACY_ENABLE_PROVIDER_CLAIMS_ACTIVITY = "AccuracyEnableProviderClaimsActivity",
    ACCURACY_ENABLE_PROVIDER_TELEHEALTH_INSPECTOR_UPDATE = "AccuracyEnableProviderTelehealthInspectorUpdate",
    ACCURACY_INSPECTION_SUMMARY_REPORT_ENHANCEMENT = "AccuracyInspectionSummaryReportEnhancement",
    ACCURACY_LARGE_PROJECT_PERFORMANCE_ENHANCEMENTS = "AccuracyLargeProjectPerformanceEnhancements",
    ADEQUACY_REPORT_CUSTOMIZATION = "AdequacyReportCustomization",
    AZURE_AI_POC = "AzureAIPOC",
    BULK_UPLOAD_LIMIT = "BulkUploadLimit",
    CCIIO_PROVIDER_VALIDATIONS = "CCIIOProviderValidations",
    DISABLE_LEGACY_BDX = "DisableLegacyBDX",
    DISTINCT_SERVICING_PROVIDER_REPORT = "DistinctServicingProviderReport",
    ECD_COLOR_CUSTOMIZATION = "EcdColorCustomization",
    ECD_REPORT_ENHANCEMENT = "EcdReportEnhancement",
    EDIT_ADEQUACY_TEMPLATE = "EditAdequacyTemplate",
    EDIT_TEMPLATE_OPTIONS = "EditTemplateOptions",
    EDIT_TAXONOMY_CODE_MAPS = "EditTaxonomyCodeMaps",
    ENABLE_CARE_JOURNEY_SCORES = "EnableCareJourneyScores",
    ENABLE_DEFAULT_VIEW_BY = "EnableDefaultViewBy",
    ENABLE_ECD_DRILLINS = "EnableEcdDrillins",
    ENABLE_NETWORK_INTEGRITY_DASHBOARD = "EnableNetworkIntegrityDashboard",
    ENABLE_VIEW_BY_INSPECTION_UPDATES = "EnableViewByInspectionUpdates",
    ENHANCED_TERMINATION = "EnhancedTermination",
    FIPS_COUNTY_CODE = "FIPSCountyCode",
    GAP_FILL_REPORT_UPDATES = "GapFillReportUpdates",
    GAP_FILL_STATUS = "GapFillStatus",
    HIDE_STRICT_TIME_DISTANCE = "HideStrictTimeDistance",
    MANAGE_HSD_PROVIDERS = "ManageHSDProviders",
    MANAGE_QES_TEMPLATES = "ManageQESTemplates",
    NCP_VOLUME_REPORTS = "NCPVolumeReports",
    NET_NEW_PROVIDER_ENRICHMENT = "NetNewProviderEnrichment",
    NETWORK_BENCHMARKING = "NetworkBenchmarking",
    NETWORK_BENCHMARKING_MARKET_PLACE = "NetworkBenchmarkingMarketPlace",
    NETWORK_BENCHMARKING_ALL_SPECIALTY_DRILL_IN = "NetworkBenchmarkingAllSpecialtyDrillIn",
    NETWORK_BENCHMARKING_MULTI_SPECIALTY = "NetworkBenchmarkingMultiSpecialty",
    NEW_PROVIDER_MANAGEMENT_UI = "NewProviderManagementUI",
    OPERATIONS_JOB_QUEUES_PAGE = "OperationsJobQueuesPage",
    PATTERN_OF_CARE_NAME_SEARCH = "PatternOfCareNameSearch",
    PATTERN_OF_CARE_LOCATION_SEARCH = "PatternOfCareLocationSearch",
    PCI_CLAIM_AMOUNTS_REPORT = "PciClaimAmountsReport",
    PCI_DASHBOARD_CPT_SEARCH_EE = "PciDashboardCPTSearchEE",
    PCI_DASHBOARD_NEW_PATIENT_CPT = "PciDashboardNewPatientCPT",
    PCI_DASHBOARD_PROCEDURE_SEARCH = "PciDashboardProcedureSearch",
    PCI_DASHBOARD_TERMINATE_GHOST_PROVIDERS = "PciDashboardTerminateGhostProviders",
    PCI_NEW_PATIENT_CPT_REPORT = "PciNewPatientCPTReport",
    PROVIDER_HUB = "ProviderHub",
    PROVIDER_HUB_CONTRACT_ENTITY = "ProviderHubContractEntity",
    PROVIDER_MEMBER_MAPS = "ProviderMemberMaps",
    PROVIDER_MEMBER_MAPS_V2 = "ProviderMemberMapsV2",
    QES_ACCURACY_ENABLE_LOCATION_WAIT_TIMES_PHASE_TWO = "QesAccuracyEnableLocationWaitTimesPhaseTwo",
    REQUIRED_TAXONOMY = "RequiredTaxonomy",
    SERVICING_PROVIDER_DATA_STAGING = "ServicingProviderDataStaging",
    SIMULATE_PROVIDER_TERMINATION = "SimulateProviderTermination",
    SNOWFLAKE_POC = "SnowflakePOC",
    SNOWFLAKE_AI_POC = "SnowflakeAIPOC",
    SPECIALTY_SUMMARY_REPORT_ALIGNMENT = "SpecialtySummaryReportAlignment",
    SSA_TO_FIPS = "SSAtoFIPS",
    STANDARD_SETTING_CREATION = "StandardSettingCreation",
    SUPPRESS_PROVIDER_IDENTIFICATION_SNAPSHOT_HINT = "SuppressProviderIdentificationSnapshotHint",
    TARGET_EXCLUDE_BY_NAME = "TargetExcludeByName",
    TERMINATE_BY_NAME = "TerminateByName",
    THIN_UNLIMITED_GEO_DISTANCE_PROVIDERS = "ThinUnlimitedGeoDistanceProviders",
    USE_90_DAY_ATTESTATIONS = "Use90DayAttestations",
    USE_AGA_PARENT_ORCHESTRATION = "UseAGASagaOrchestration",
    USE_XIDS_IN_QES_ACCURACY = "UseXIDsInQESAccuracy",
    VOLUME_EXCEPTIONS = "VolumeExceptions",
    VOLUME_EXCEPTIONS_ADD_WIZARD = "VolumeExceptionsAddWizard",
    VOLUME_EXCEPTIONS_ARCHIVE = "VolumeExceptionsArchive",
    VOLUME_EXCEPTIONS_BULK_UPLOAD = "VolumeExceptionsBulkUpload",
    VOLUME_EXCEPTIONS_DOWNLOAD_ALL = "VolumeExceptionsDownloadAll",
    VOLUME_EXCEPTIONS_EXPIRE = "VolumeExceptionsExpire",
    VOLUME_EXCEPTIONS_SUPPLEMENTARY_DOCUMENTS = "VolumeExceptionSupplementaryDocs",
    VOLUME_GHOST_PROVIDER_TERMINATIONS = "VolumeGhostProviderTerminations",
    VOLUME_REPORTING_CARGO_COLUMN_OPTION = "VolumeReportingCargoColumnOption",
    ZIP_ANALYSIS_CHANGED_GAPS = "ZipAnalysisChangedGaps",
    ZIP_ANALYSIS_TRENDING = "ZipAnalysisTrending",
    ZIP_CODE_ANALYSIS_TARGETING = "ZipCodeAnalysisTargeting",
    ZIP_CODE_ANALYSIS_TERMINATION = "ZipCodeAnalysisTermination",
    ZIP_PROSPECT_AND_MARKET = "ZipProspectAndMarket",
}

export default Features;